import { render, staticRenderFns } from "./CardAdvantage.vue?vue&type=template&id=aaeb133a&scoped=true&"
import script from "./CardAdvantage.vue?vue&type=script&lang=ts&"
export * from "./CardAdvantage.vue?vue&type=script&lang=ts&"
import style0 from "./CardAdvantage.vue?vue&type=style&index=0&id=aaeb133a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaeb133a",
  null
  
)

export default component.exports